/* src/app/bulk-tag-dialog/bulk-tag-dialog.component.scss */
.bulk-tag-modal {
  background: white;
  border-radius: 6px;
  width: 100%;
  max-width: 520px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.bulk-tag-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 24px 14px;
  border-bottom: 1px solid #e0e0e0;
}
.bulk-tag-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.bulk-tag-subtitle {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}
.bulk-tag-close {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #888;
  padding: 2px 4px;
}
.bulk-tag-close:hover {
  color: #333;
}
.bulk-tag-body {
  padding: 16px 24px;
  overflow-y: auto;
  flex: 1;
}
.bulk-tag-section {
  margin-bottom: 16px;
}
.bulk-tag-label {
  font-size: 13px;
  color: #555;
  margin-bottom: 6px;
}
.bulk-tag-clients-preview {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px 12px;
  max-height: 80px;
  overflow-y: auto;
  background: #fafafa;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}
.bulk-tag-clients-preview::-webkit-scrollbar {
  width: 4px;
}
.bulk-tag-clients-preview::-webkit-scrollbar-track {
  background: transparent;
}
.bulk-tag-clients-preview::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 2px;
}
.client-name-chip {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  background: white;
  border: 1px solid #e0e0e0;
  color: #333;
}
.bulk-tag-toggle {
  display: flex;
  gap: 4px;
  background: #f5f5f5;
  padding: 4px;
  border-radius: 6px;
  margin-bottom: 16px;
}
.toggle-option {
  flex: 1;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
  color: #666;
  transition: background 0.15s, color 0.15s;
}
.toggle-option.toggle-active {
  background: white;
  color: #333;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.bulk-tag-search {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 13px;
  margin-bottom: 8px;
  box-sizing: border-box;
}
.bulk-tag-search:focus {
  outline: none;
  border-color: #999;
}
.bulk-tag-list {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 220px;
  overflow-y: auto;
  margin-bottom: 12px;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}
.bulk-tag-list::-webkit-scrollbar {
  width: 4px;
}
.bulk-tag-list::-webkit-scrollbar-track {
  background: transparent;
}
.bulk-tag-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 2px;
}
.bulk-tag-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  font-size: 13px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  color: #333;
}
.bulk-tag-row:last-child {
  border-bottom: none;
}
.bulk-tag-row:hover {
  background: #fafafa;
}
.bulk-tag-row.bulk-tag-row-selected {
  background: #f0f4ff;
}
.bulk-check {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid #bbb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: white;
}
.bulk-check .bulk-check-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
  color: #3f47cc;
}
.bulk-tag-row-selected .bulk-check {
  background: #3f47cc;
  border-color: #3f47cc;
}
.bulk-tag-row-selected .bulk-check .bulk-check-icon {
  color: white;
}
.bulk-tag-coverage {
  margin-left: auto;
  font-size: 11px;
  color: #999;
  white-space: nowrap;
}
.bulk-tag-empty {
  padding: 16px;
  text-align: center;
  color: #999;
  font-size: 13px;
}
.bulk-tag-create {
  color: #3f47cc;
  font-style: italic;
}
.bulk-tag-create:hover {
  background: #f0f4ff;
}
.bulk-tag-summary {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}
.bulk-tag-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 24px 20px;
  border-top: 1px solid #e0e0e0;
}
.bulk-footer-cancel {
  border: 1px solid #333;
  background: white;
  color: #333;
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.bulk-footer-cancel:hover {
  background: #f5f5f5;
}
.bulk-footer-apply {
  border: 1px solid #3f47cc;
  background: #3f47cc;
  color: white;
  padding: 6px 18px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.bulk-footer-apply:hover {
  background: #353db5;
}
.bulk-footer-apply:disabled {
  background: #bdbdbd;
  border-color: #bdbdbd;
  cursor: default;
}
/*# sourceMappingURL=bulk-tag-dialog.component.css.map */
